exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".nivelBox {\n  height: 20px;\n  font-weight: bold;\n  text-align: center; }\n\n.mesBox {\n  float: left;\n  margin-left: 10px; }\n\n.boxVerde {\n  background-color: #a9e53b !important; }\n\n.boxNaranja {\n  background-color: #e6ac30 !important; }\n\n.boxNeutro {\n  background-color: #ccc !important; }\n\n.linea {\n  margin: 2px;\n  padding: 0px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/adri9/Escritorio/admin-everpath/src/app/componentes/graficas/barChartDash/barChartDash.component.scss
// module id = ../../../../../src/app/componentes/graficas/barChartDash/barChartDash.component.scss
// module chunks = main